import Layout from '@/layout'

export default {
  path: '/invoice',
  name: 'Invoice',
  component: Layout,
  meta: { title: '发票管理', role: 1555, icon: 'invoice' },
  children: [
    // {
    //   path: 'wait-list',
    //   name: 'WaitList',
    //   component: () => import('@/pages/invoice/wait-list'),
    //   meta: {title: '待申请开票', role: 0},
    // },
    {
      path: 'choose-list',
      name: 'ChooseList',
      component: () => import('@/pages/invoice/choose-list'),
      meta: { title: '申请发票', role: 1556 }
    },
    {
      path: 'choose-apply',
      name: 'ChooseApply',
      component: () => import('@/pages/invoice/choose-apply'),
      hidden: true,
      meta: { title: '待开票详情', role: 1556, noCache: true }
    },
    {
      path: 'invoice-list',
      name: 'InvoiceList',
      component: () => import('@/pages/invoice/invoice-list'),
      props: route => ({ tab: route.query.tab }),
      meta: { title: '发票申请列表', role: 1556, noCache: true }
    },
    {
      path: 'invoice-detail/:id',
      name: 'InvoiceDetail',
      props: true,
      hidden: true,
      component: () => import('pages/invoice/invoice-detail'),
      meta: { title: '发票详情', role: 1556, noCache: true }
    }
  ]
}
